import { makeStyles } from '@material-ui/core/styles'

export default makeStyles(theme => ({
  root: {
    width: '100%',
    position: 'relative',
    paddingTop: '100px',
    paddingBottom: '50px',
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    justifyContent: 'center',
    alignItems: 'center'
  },
  container: {
    width: '100%',
    [theme.breakpoints.up('md')]: {
      maxWidth: '1140px'
    },
    [theme.breakpoints.down('md')]: {
      maxWidth: '960px'
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: '720px'
    },
    [theme.breakpoints.down('xs')]: {
      maxWidth: '540px'
    }
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center'
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'center',
    flexWrap: 'wrap'
  },
  title: {
    textAlign: 'center',
    color: '#451295',
    fontSize: '28px',
    fontWeight: 'bold'
  },
  imageContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  image: {
    width: '330px',
    marginTop: '45px',
    [theme.breakpoints.down('md')]: {
      background: 'none',
      border: 'none'
    }
  },
  mktInner: {
    width: 'auto',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  mktContent: {
    width: '58.33%',
    [theme.breakpoints.down('md')]: {
      width: '50%'
    },
    [theme.breakpoints.down('sm')]: {
      width: '83.3%'
    }
  },
  content: {
    width: '41.66%',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      width: '50%'
    },
    [theme.breakpoints.down('sm')]: {
      width: '83.33%'
    }
  }
}))
